import React from 'react';
import {
  Label,
  TextField,
  Text,
  MaskedTextField,
  Icon,
  CompactPeoplePicker,
  IBasePickerSuggestionsProps,
  ISelectableOption,
  ComboBox,
  IComboBox,
  IComboBoxStyles,
} from '@fluentui/react';
import ComboBoxSearch from '../../Common/ComboBoxSearch';
import { IComboBoxOption, Dropdown, Image } from '@fluentui/react';
import { Club } from '../../../system/Club/Club';
import { DocumentoTipo } from '../../../system/DocumentoTipo/DocumentoTipo';
import DialogTemplate from '../../Common/DialogTemplate';
import { AppContext } from '../../../AppInRouterContext';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import { Jugador } from '../../../system/Jugador/Jugador';

interface IDatosIniciales {
  selectedClubId: string;
  setSelectedClubId: (id: string) => void;
  documentoNumero: string;
  setDocumentoNumero: (num: string) => void;
  selectedTipoDocumentoId: string;
  setSelectedTipoDocumentoId: (id: string) => void;
  documentoTipos: DocumentoTipo[];
  clubes: Club[];
  isDni: boolean;
}

export const DatosIniciales = (props: IDatosIniciales) => {
  const clubesOptions: IComboBoxOption[] = React.useMemo(() => {
    if (props.clubes)
      return props.clubes.map((club) => ({
        key: club.getId()!,
        text: club.getSigla() ? club.getSigla()! : '',
        data: club,
      }));
    else return [];
  }, [props.clubes]);

  const documentoTiposOptions: IComboBoxOption[] = React.useMemo(() => {
    if (props.documentoTipos)
      return props.documentoTipos.map((documentoTipo) => ({
        key: documentoTipo.getId()!,
        text: documentoTipo.getDescripcion(),
      }));
    else return [];
  }, [props.documentoTipos]);

  const comboStyle: IComboBoxStyles = {
    container: undefined,
    label: undefined,
    labelDisabled: undefined,
    root: undefined,
    rootError: undefined,
    rootDisallowFreeForm: undefined,
    rootHovered: undefined,
    rootPressed: undefined,
    rootFocused: undefined,
    rootDisabled: undefined,
    input: undefined,
    inputDisabled: undefined,
    errorMessage: undefined,
    callout: { maxHeight: '200px', minWidth: '-webkit-fill-available;' },
    optionsContainerWrapper: { maxHeight: '200px', minWidth: '-webkit-fill-available;' },
    optionsContainer: { maxHeight: '200px', minWidth: '-webkit-fill-available;' },
    header: undefined,
    divider: undefined,
    screenReaderText: undefined,
  };
  return (
    <div>
      <div>
        <Label>Club</Label>
        <ComboBoxSearch
          options={clubesOptions}
          selected={[props.selectedClubId]}
          onSelectOption={function (opt: IComboBoxOption): void {
            props.setSelectedClubId(opt.key.toString());
          }}
          comboStyles={comboStyle}
          onRenderOption={(option) => <OnRenderOption option={option} />}
        ></ComboBoxSearch>
        {/* <Dropdown
          options={clubesOptions}
          selectedKey={props.selectedClubId}
          onChange={(e, opt: any) => props.setSelectedClubId(opt.key.toString())}
          onRenderOption={(option) => (
            <OnRenderOption option={option} />
          )}
        ></Dropdown> */}
      </div>

      <div>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3" style={{ paddingLeft: 0 }}>
              <Label>Tipo</Label>
              <Dropdown
                options={documentoTiposOptions}
                selectedKey={props.selectedTipoDocumentoId}
                onChange={(e, opt: any) => props.setSelectedTipoDocumentoId(opt.key.toString())}
              ></Dropdown>
            </div>
            <div className="ms-Grid-col ms-sm9" style={{ paddingRight: 0 }}>
              <Label>Documento</Label>
              <TextField
                value={props.documentoNumero}
                onChange={(e, nv) => props.setDocumentoNumero(nv ? (props.isDni ? formatMiles(nv) : nv) : '')}
                type="text" // Siempre 'text' ya que 'inputMode' maneja el teclado
                inputMode={props.isDni ? 'numeric' : 'text'} // Muestra el teclado numérico solo si es un DNI
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5">
        <Text variant="small">
          <Icon
            iconName="AlertSolid"
            className="warning-color"
            style={{ position: 'relative', top: 2, marginRight: 3, color: '#f5a106' }}
          ></Icon>
          Recorda que si tu apto medico no se encuentra subido antes de la fecha limite, no podras participar
          en los partidos de tu equipo!
        </Text>
      </div>
    </div>
  );
};

export const formatMiles = (value: string | number): string => {
  const ret = value
    .toString()
    .replace(/\D/g, '') // Elimina cualquier carácter no numérico
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Agrega los puntos como separadores de miles
  return ret;
};

export const OnRenderOption = ({ option }: { option: ISelectableOption<any> | undefined }): JSX.Element => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        // padding: "8px 12px",
        cursor: 'pointer', // Asegura que parece clicable
        backgroundColor: 'transparent', // Fondo por defecto
        transition: 'background-color 0.2s', // Suaviza el cambio de color en hover
        maxWidth: '-webkit-fill-available',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#f3f2f1'; // Cambia el fondo al hacer hover
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent'; // Vuelve al fondo por defecto
      }}
    >
      {/* Imagen del club */}
      <Image
        src={
          (option!.data as Club).getEscudo()
            ? (option!.data as Club).getEscudo()
            : 'images/escudo_default.jpg'
        }
        width={25}
        height={25}
        alt={option!.text}
      />
      {/* Texto de la opción */}
      <span
        className="text-overflow"
        style={{ maxWidth: 200, marginLeft: 8, flexGrow: 1, verticalAlign: 'middle' }}
      >
        {option!.text}
      </span>
    </div>
  );
};
